var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentMandiri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2860.65 834.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00366c;}.cls-2{fill:#fabd00;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo Bank Mandiri") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3,573.78c0-41.49-.76-76.24-3-107.29H78.42l3.7,53.26h2.19c17.76-28.11,50.32-61.43,111-61.43,47.37,0,84.31,26.77,99.79,66.64h1.52c12.7-20,27.42-34.74,44.42-45.09C361,465.82,384,458.32,413.58,458.32,473.41,458.32,534,499.05,534,614.5V826.72H445.3v-199c0-59.83-20.7-95.42-64.29-95.42-31.13,0-54.1,22.22-63.61,48.13-2.27,8.92-4.54,19.94-4.54,30.29v216H224.08V618.12c0-50.24-19.94-85.83-62.09-85.83-34,0-56.89,26.67-65.06,51.75-3.69,8.92-5.21,19.27-5.21,29.62V826.72H3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M791.1,650.74C726.73,649.23,665.3,663.2,665.3,718c0,35.52,23,51.84,51.83,51.84,36.19,0,62.87-23.64,70.94-49.56l3-20Zm88.7,89.45c0,32.57,1.51,64.21,5.21,86.51H802.88l-5.89-40h-2.27c-22.22,28.2-59.92,48.13-106.45,48.13-72.53,0-113.17-52.41-113.17-107.29,0-90.95,80.61-136.82,213.73-136v-5.9c0-23.73-9.67-62.94-73.21-62.94-35.51,0-72.54,11.19-96.93,26.68l-17.76-59.16c26.68-16.32,73.29-31.89,130.17-31.89,115.46,0,148.7,73.29,148.7,151.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M942.72,573.78c0-41.49-.84-76.24-2.94-107.29h79.78l4.45,54h2.18c15.57-28.11,54.79-62.19,114.7-62.19,62.94,0,128,40.73,128,154.58V826.72h-91V623.34c0-51.83-19.27-91.05-68.74-91.05-36.27,0-61.34,25.83-71,53.27-2.87,8.15-3.71,19.27-3.71,29.53V826.72H942.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1572.29,616.62,1570.1,593c-8.15-35.51-36.94-64.28-78.42-64.28-58.4,0-91,51.75-91,119.06,0,65.8,32.56,113.94,90.29,113.94,36.85,0,69.5-25.16,78.33-64.38,2.19-8.15,3-17.08,3-26.67Zm91-294.85V725.43c0,36.94,1.51,76.9,2.93,101.31h-81.28l-3.69-57h-1.52c-21.38,39.89-65.22,65-117.64,65-85.75,0-153.83-73.12-153.83-184.11-.75-120.58,74.73-192.36,161.32-192.36,49.48,0,85,20.7,101.31,47.46h1.43v-184Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1727.6,
    y: 466.44,
    width: 91.89,
    height: 360.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1883.66,582.63c0-48.8-.76-83.63-3-116.11h79.19l2.85,68.74h3c17.76-51.07,59.92-68.74,98.37-68.74,8.92,0,14.06-1.52,21.46,0v79.93a123.11,123.11,0,0,0-26.67-3c-43.6,0-73.21,28.11-81.3,68.75a154.86,154.86,0,0,0-2.93,28.27V826.66h-91Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2127.8,
    y: 466.44,
    width: 91.63,
    height: 360.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2785.42,86c-45.27-51.59-93.31-28.28-131.6-9.26-16.07,7.91-74.39,46.78-132.2,73.8-41.15,19.27-100.3,13.46-132.69-26.5-1.94-2.45-54.36-66-59.92-73.81-34-42.66-120.08-78-222.91-19.18C2051,62.92,1921.15,137.39,1872.61,165.16c-29.46,15.06-98,21.63-136.66-30.63L1682.43,67.8c-1.52-1.68-34.33-50.4-107.54-51.91-10.77-.26-64.46-.59-117.05,29.28C1388.25,85,1226.1,177.61,1226.1,177.61l-.08.09c-66.65,38.2-118.64,67.82-118.64,67.82l61.34,75.4c28.77,35.59,93.49,63.19,149.61,31l208.1-120.42c89.69-49.23,158.94-49.23,204.81-30.89,41.23,17.34,77.07,60.76,77.07,60.76s47,58.15,55.21,68.33c26.67,32.82,70.76,19.93,70.76,19.93s16.33-1.93,41.06-16.57l200.94-116.45c63.79-37.46,122.36-44.44,152.23-41.66,93.56,8.5,122.68,73.88,163.32,119.58,23.9,26.84,45.44,42.07,78.43,41.31,21.71-.5,46.2-13.63,49.81-16L2860.65,181s-24.65-37.11-75.23-95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMandiri);
export default __webpack_public_path__ + "static/media/payment_mandiri.8bf03ba285c6692ac4e0eb55d2c72da3.svg";
export { ForwardRef as ReactComponent };